<template>
  <r-panel :disabled="disabled" :title="title" :empty="items.length === 0" :button_add="true" @click_add="click_add">
    <r-card-album-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {CardAlbumModel} from "@/modules/redactor/models/card/CardAlbumModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCardAlbumTable from "@/modules/redactor/views/card-album/r-card-album-table.vue";


export default {
  name: "r-card-album-panel",
  components: {RCardAlbumTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Albums"),
    items: VueTypes.arrayOf(CardAlbumModel)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
